module.exports = __webpack_public_path__ + "static/img/haevichi.d3a8ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/haevichi.jpg
// module id = P5Wj
// module chunks = 0